import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { generateRandomID } from "~/utils/generateRandomID";
import { AssetChatStoreState, OpenNewChatPayload } from "./types";

// // // //

// Define the initial state of the asset_chat store
const initialState: AssetChatStoreState = {
    openNewChatRequest: null,
    isChatOpen: false,
};

// Define the slice for the asset_chat store, including the initial state and reducer functions
const assetChatSlice = createSlice({
    name: "assetChat",
    initialState,
    reducers: {
        // Request that GlobalChatDock open a new chat for the given asset. A fresh
        // requestId is stamped so repeated requests for the same asset still fire.
        openNewChat: (state, action: PayloadAction<OpenNewChatPayload>) => {
            state.openNewChatRequest = {
                ...action.payload,
                requestId: generateRandomID(),
            };
        },
        // Clear the outstanding request. GlobalChatDock calls this once it has
        // consumed the request and opened the chat.
        clearOpenNewChatRequest: (state) => {
            state.openNewChatRequest = null;
        },
        // Mirror whether a chat is currently open in the dock. GlobalChatDock is
        // the only dispatcher, syncing this from its local open state.
        setChatOpen: (state, action: PayloadAction<boolean>) => {
            state.isChatOpen = action.payload;
        },
    },
});

// Export the reducer function and action creators from the slice
export const { openNewChat, clearOpenNewChatRequest, setChatOpen } =
    assetChatSlice.actions;
export const reducer = assetChatSlice.reducer;
